import { render } from "./SignageDetails.vue?vue&type=template&id=92fbea8e&scoped=true&ts=true"
import script from "./SignageDetails.vue?vue&type=script&lang=ts"
export * from "./SignageDetails.vue?vue&type=script&lang=ts"

import "./SignageDetails.vue?vue&type=style&index=0&id=92fbea8e&lang=css"
import "./SignageDetails.vue?vue&type=style&index=1&id=92fbea8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92fbea8e"]])

export default __exports__